import moment from "moment";
import { EnumEstadoInformeConservacion } from "../../../Utils/Enumeradores/ComunEnum";

export const COLUMNS = [
	{
		Header: 'ID',
		accessor: 'informeConservacionId',
	},
	{
		Header: 'Archivo',
		accessor: 'nombreArchivoEstandar',
        Cell: ({row}) => <a
                href={row.original.rutaArchivo}
                target="_blank"
                rel="noopener noreferrer"
                download={row.original.nombreArchivoEstandar}
                style={{ color: "blue" }}
            >
            {row.original.nombreArchivoEstandar}
      </a>
	},
    {
		Header: 'Exigencia',
		accessor: 'exigencia.sigla',
	},
	{
		Header: 'Cant. Registros',
		accessor: 'cantidadRegistros',
	},
	{
		Header: 'Cant. Reg. Fallidos',
		accessor: 'cantidadRegistrosFallidos',
	},
	{
		Header: 'Fecha Carga',
		accessor: 'fechaCarga',
		Cell: ({row}) => <spam>
			{moment(row.original.fechaCarga).format('DD-MM-YYYY')}
		</spam>
	},
	{
		Header: 'Origen',
		accessor: 'usuarioCarga.origen',
	},
	{
		Header: 'Estado',
		accessor: 'estado',
        Cell: ({row}) => 
            <span>
                {EnumEstadoInformeConservacion[row.original.estado]}
            </span>
        
	},
	{
		Header: 'Usuario',
		accessor: 'usuarioCarga',
		Cell: ({ row }) => <span>{`${row.original.usuarioCarga.nombres} ${row.original.usuarioCarga.apellidoPaterno}`}</span>
	},
]
